import { SeoController } from '@application/components';
import { useRouter, useValidation } from '@application/utils';
import type { JoinShelterPageFormValues } from '@presentation/pages';
import { JoinShelterPage } from '@presentation/pages';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { SchemaOf } from 'yup';
import { object, string } from 'yup';
import { useSendContactMessage } from './api/useSendContactMessage';

export const JoinShelterPageController: FC = () => {
  const { translate } = useRouter();

  const { emailMessage, requiredMessage } = useValidation();
  const { sendContactMessageFromForm } = useSendContactMessage();

  const validationSchema = useMemo(() => {
    const schema: SchemaOf<JoinShelterPageFormValues> = object({
      firstName: string().required(requiredMessage),
      lastName: string().required(requiredMessage),
      email: string().email(emailMessage).required(requiredMessage),
      phone: string().required(requiredMessage),
    }).defined();
    return schema;
  }, [emailMessage, requiredMessage]);

  return (
    <>
      <SeoController
        title={translate('signup.shelter.seo.title')}
        description={translate('signup.shelter.seo.description')}
        keywords={translate('signup.shelter.seo.keywords')}
      />
      <JoinShelterPage
        form={{
          initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
          },
          onSubmit: sendContactMessageFromForm,
          validationSchema,
        }}
      />
    </>
  );
};
